const cookies = () => {
  const cookiesEl = document.querySelector('.js-cookies');
  if (cookiesEl) {
    const cookiesAccept = localStorage.getItem('cookiesAccept');
    if (cookiesAccept === 'true') {
      return;
    }
    cookiesEl.classList.add('is-active');
    const cookiesButton = document.querySelector('.js-cookies-button');
    if (cookiesButton) {
      cookiesButton.addEventListener('click', () => {
        localStorage.setItem('cookiesAccept', 'true');
        cookiesEl.classList.remove('is-active');
      });
    }
  }
};

export default cookies;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/cookies.js